import styled from "styled-components";

const SubCardTitle = styled.p`
  font-weight: 500;
  &:after {
    content: "";
    display: block;
    border-bottom: 2px solid var(--primary-text-color);
    margin-bottom: 5px;
    width: 50px;
  }
`;

export default SubCardTitle;
